export const getLocalizationApiUrl = (): string => {
	const { REACT_APP_LOCALIZATION_API_URL: url } = process.env;
	return `${url}/api/v1/translations`;
};
